import React from "react";
import {SelectProps} from "@mui/material/Select/Select";
import {FormikProps} from "formik";
import {GridTypeMap} from "@mui/material/Grid/Grid";
import {TFunction} from "i18next";
import {Grid} from "@mui/material";
import FormSelectField from "./FormSelectField";
import {get} from "lodash";
import MenuItem from "@mui/material/MenuItem";
import {ListRequestParams, useOrganizationStageListQuery} from "../../app/api/api";

export const NO_SELECTION = "no_selection";

export type OrganizationStageSelectProps = Omit<SelectProps, "label"> & {
    fieldName: string;
    label: string;
    form: FormikProps<any>;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    t: TFunction;
    requestParams?: ListRequestParams;
    hideEmptyOption?: boolean;
};

const OrganizationStageSelect = ({
    fieldName,
    label,
    form,
    t,
    isGridItem = false,
    gridProps = {xs: 6},
    requestParams = {},
    hideEmptyOption = false,
    ...rest
}: OrganizationStageSelectProps) => {
    // get the organizationId and the remaining params from the requestParams
    const {organizationId, ...restParams} = requestParams;
    const {data: stageListResponse} = useOrganizationStageListQuery({
        id: Number(organizationId),
        params: restParams,
    });
    const getSelect = () => (
        <>
            <FormSelectField
                fieldName={fieldName}
                form={form}
                label={label}
                labelId={`label-${fieldName}`}
                {...rest}
                value={(stageListResponse?.payload || []).length > 0 ? get(form?.values, fieldName) : NO_SELECTION}
            >
                {!hideEmptyOption && (
                    <MenuItem key={"no_selection"} value={NO_SELECTION}>{`${t("productiveStage_noStage")}`}</MenuItem>
                )}
                {(stageListResponse?.payload || []).map((s) => {
                    return (
                        <MenuItem value={s.identifier} key={s.identifier}>
                            {s.description}
                        </MenuItem>
                    );
                })}
            </FormSelectField>
        </>
    );
    return isGridItem ? (
        <Grid item {...gridProps}>
            {getSelect()}
        </Grid>
    ) : (
        getSelect()
    );
};
export default OrganizationStageSelect;
